function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37 23.5h23.5c1.105 0 1.991-.906 2.255-1.978.62-2.516 2.48-5.522 6.745-5.522 5.124 0 6.776 4.34 6.978 6.954a.582.582 0 0 0 .57.546.547.547 0 0 0 .537-.445L79.5 13c-2.376-1.9-8.897-2.047-17.617-2.437a3.99 3.99 0 0 1-2.43-.966L51.19 2.459A6 6 0 0 0 47.268 1H24.795a7 7 0 0 0-4.821 1.925l-7.702 7.317a1.002 1.002 0 0 1-.647.274c-3.779.167-6.109.334-9.55.825a.994.994 0 0 0-.823 1.216l1.958 8.225a2 2 0 0 0 1.512 1.49L8 23s1-7 7.5-7c5.403 0 6.636 4.468 6.917 6.507.075.547.53.993 1.083.993H37zm0 0v-15m0 0V4a1 1 0 0 0-1-1h-9.952a2 2 0 0 0-1.644.862L21.585 7.93A1 1 0 0 0 22.41 9.5h12.763a2 2 0 0 0 1.414-.586L37 8.5zM20.5 13H24m15.5 0H43m-2.5-3.5h12.716c.872 0 1.326-1.038.735-1.678l-3.857-4.179A2 2 0 0 0 48.624 3H40.5a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1z",
  stroke: "#E4ECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M69.64 28.597a5.867 5.867 0 1 1 0-11.72 5.86 5.86 0 0 1 0 11.72zm0-10.796a4.944 4.944 0 1 0 4.954 4.93 4.874 4.874 0 0 0-1.462-3.492 4.827 4.827 0 0 0-3.48-1.438h-.012z",
  fill: "#E4ECFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M69.64 25.558a2.837 2.837 0 1 1-.002-5.675 2.837 2.837 0 0 1 .002 5.675zm0-4.737a1.912 1.912 0 1 0 .003 3.823 1.912 1.912 0 0 0-.003-3.822zM15.64 28.597a5.867 5.867 0 1 1 0-11.72 5.86 5.86 0 0 1 0 11.72zm0-10.796a4.944 4.944 0 1 0 4.954 4.93 4.874 4.874 0 0 0-1.462-3.492 4.827 4.827 0 0 0-3.48-1.438h-.012z",
  fill: "#E4ECFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.64 25.558a2.837 2.837 0 1 1-.002-5.675 2.837 2.837 0 0 1 .002 5.675zm0-4.737a1.912 1.912 0 1 0 .003 3.823 1.912 1.912 0 0 0-.003-3.822z",
  fill: "#E4ECFF"
});

var SvgPrivatePassenger = function SvgPrivatePassenger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 29,
    viewBox: "0 0 81 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrivatePassenger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/privatePassenger.dcff4111.svg";
export { ForwardRef as ReactComponent };